import { Currency } from '@/core/currency/interfaces';

const SHP: Currency = {
    name: 'Saint Helena Pound',
    demonym: 'Saint Helena',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '654',
    symbol: '£',
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SHP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SHP;
